import { salesOrdersContracts } from "./sales-orders.contract";
import { salesOrderDraftsContracts } from "./sales-order-drafts.contract";
import { draftSalesOrdersContracts } from "./draft-sales-orders.contract";
import { salesOrdersV3Contracts } from "./sales-orders-v3.contract";
import { customerProductsContracts } from "./customer-products.contract";
import { discountsContracts } from "./discounts.contract";
import { discountsV2Contracts } from "./discounts-v2.contract";
import { orderApprovalsContracts } from "./order-approvals.contract";
import { salesOrdersRpcContracts } from "./sales-orders-rpc.contract";
import { arSyncContracts } from "./ar-sync.contract";
import { arInvoicesContracts } from "./ar-invoices.contract";
import { arPaymentsContracts } from "./ar-payments.contract";
import { arPaymentApplicationsContracts } from "./ar-payment-applications.contract";
import { arAgingContracts } from "./ar-aging.contract";
import { arSummaryContracts } from "./ar-summary.contract";
import { orderStageReportContracts } from "./order-stage-report.contract";
import { arCustomAgingContracts } from "./ar-custom-aging.contract";
import { arSavedReportsContracts } from "./ar-saved-reports.contract";
import { arCustomerProfileContracts } from "./ar-customer-profile.contract";
import { arCustomerIntelligenceContracts } from "./ar-customer-intelligence.contract";
import { arCashReceiptsContracts } from "./ar-cash-receipts.contract";
import { arCustomerContactsContracts } from "./ar-customer-contacts.contract";
import { arCustomerCommsContracts } from "./ar-customer-comms.contract";
import { arStatementEmailContracts } from "./ar-statement-email.contract";
import { arInvoiceEmailContracts } from "./ar-invoice-email.contract";
import { arInvoiceFromSalesOrderContracts } from "./ar-invoice-from-sales-order.contract";
import { arStatementDefaultsContracts } from "./ar-statement-defaults.contract";
import { approvalConfigContracts } from "./approval-config.contract";
import { arRemittancesContracts } from "./ar-remittances.contract";
import { priceListsContracts } from "./price-lists.contract";
import { arCollectionThreadsContracts } from "./ar-collection-threads.contract";
import { arCollectionsAgentActionsContracts } from "./ar-collections-agent-actions.contract";
import { arCollectionEmailDraftsContracts } from "./ar-collection-email-drafts.contract";
import { arShortPayRecommendationsContracts } from "./ar-short-pay-recommendations.contract";
import { arOverPaymentRecommendationsContracts } from "./ar-over-payment-recommendations.contract";
import { arCustomerCommsNotesContracts } from "./ar-customer-comms-notes.contract";

export const accountsReceivableContracts = {
  stagedSalesOrders: salesOrdersContracts,
  salesOrderDrafts: salesOrderDraftsContracts,
  draftSalesOrders: draftSalesOrdersContracts,
  salesOrdersV3: salesOrdersV3Contracts,
  customerProducts: customerProductsContracts,
  discounts: discountsContracts,
  discountsV2: discountsV2Contracts,
  orderApprovals: orderApprovalsContracts,
  salesOrders: salesOrdersRpcContracts,
  arSync: arSyncContracts,
  arInvoices: arInvoicesContracts,
  arPayments: arPaymentsContracts,
  arPaymentApplications: arPaymentApplicationsContracts,
  arAging: arAgingContracts,
  arSummary: arSummaryContracts,
  orderStageReport: orderStageReportContracts,
  arCustomAging: arCustomAgingContracts,
  arSavedReports: arSavedReportsContracts,
  arCustomerProfile: arCustomerProfileContracts,
  arCustomerIntelligence: arCustomerIntelligenceContracts,
  arCashReceipts: arCashReceiptsContracts,
  arCustomerContacts: arCustomerContactsContracts,
  arCustomerComms: arCustomerCommsContracts,
  arStatementEmail: arStatementEmailContracts,
  arInvoiceEmail: arInvoiceEmailContracts,
  arInvoiceFromSalesOrder: arInvoiceFromSalesOrderContracts,
  arStatementDefaults: arStatementDefaultsContracts,
  approvalConfig: approvalConfigContracts,
  arRemittances: arRemittancesContracts,
  priceLists: priceListsContracts,
  arCollectionThreads: arCollectionThreadsContracts,
  arCollectionsAgentActions: arCollectionsAgentActionsContracts,
  arCollectionEmailDrafts: arCollectionEmailDraftsContracts,
  arShortPayRecommendations: arShortPayRecommendationsContracts,
  arOverPaymentRecommendations: arOverPaymentRecommendationsContracts,
  arCustomerCommsNotes: arCustomerCommsNotesContracts,
} as const;

export * from "./sales-orders-rpc.contract";
export * from "./ar-sync.contract";
export * from "./ar-invoices.contract";
export * from "./ar-payments.contract";
export * from "./ar-payment-applications.contract";
export * from "./ar-aging.contract";
export * from "./ar-summary.contract";
export * from "./order-stage-report.contract";
export * from "./ar-custom-aging.contract";
export * from "./ar-saved-reports.contract";
export * from "./ar-customer-profile.contract";
export * from "./ar-customer-intelligence.contract";
export * from "./ar-cash-receipts.contract";
export * from "./ar-customer-contacts.contract";
export * from "./ar-customer-comms.contract";
export * from "./ar-email-shared.contract";
export * from "./ar-statement-email.contract";
export * from "./ar-invoice-email.contract";
export * from "./ar-invoice-from-sales-order.contract";
export * from "./ar-statement-defaults.contract";
export * from "./order-approvals.contract";
export * from "./approval-config.contract";
export * from "./ar-remittances.contract";
export * from "./price-lists.contract";
export * from "./ar-collection-threads.contract";
export * from "./ar-collections-agent-actions.contract";
export * from "./ar-collection-email-drafts.contract";
export * from "./ar-short-pay-recommendations.contract";
export * from "./ar-over-payment-recommendations.contract";
export * from "./ar-customer-comms-notes.contract";
export * from "./discounts-v2.contract";
